/**
 * loại Mẫu báo cáo biên bản kiểm kê TSCĐ
 * NXCHIEN 28.12.2022
 */
export default {
  TT_107: 1,
  Category_FixedAsset: 2,
};
